module.exports = __webpack_public_path__ + "img/两颗爱心.8e9946f4.png";